import Earth16 from '@carbon/icons-react/es/earth/16';
import UserAvatar16 from '@carbon/icons-react/es/user--avatar/16';
import React from 'react';
import { View, ViewType } from 'api/views/types';
import { defaultFilter } from 'components/molecules/filters/utils';
import { ColumnOrder } from 'components/organisms/grid-custom-column';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { FilterableField } from 'components/organisms/tasks/fields';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { ProjectListViewDefinition, ProjectViews } from './views';

export const getDefaultProjectView = (
  fields_lookup_by_name: Record<string, FilterableField>,
  userId: number,
  defaultColumnOrder: ColumnOrder[],
): View<ProjectListViewDefinition>[] => {
  const teamMember = fields_lookup_by_name.teamMembers;

  return [
    {
      viewId: ProjectViews.MyProjects,
      viewName: 'My Projects',
      viewIcon: <UserAvatar16 />,
      viewDefinition: {
        filter: {
          criteria: [
            {
              field: teamMember,
              type: SelectFilterOperationType.IsOneOf,
              value: [userId],
            },
          ],
          type: QueryCombinerType.All,
        },
        groupBy: 'none',
      },
      createdBy: -1,
      self: false,
      viewType: ViewType.ProjectList,
    },
    {
      viewId: ProjectViews.AllProjects,
      viewName: 'All projects',
      viewIcon: <Earth16 />,
      viewDefinition: { filter: defaultFilter, groupBy: 'none' },
      createdBy: -1,
      self: false,
      viewType: ViewType.ProjectList,
    },
  ].map(
    (view) =>
      ({
        ...view,
        viewDefinition: {
          ...view.viewDefinition,
          columnOrder: defaultColumnOrder,
        },
      } as View<ProjectListViewDefinition>),
  );
};
